(() => {
  const dialog = document.querySelector('[data-joa-welcome-offer]');
  if (!dialog) return;
  let config;
  try { config = JSON.parse(dialog.querySelector('[data-joa-offer-config]').textContent); } catch { return; }
  if (!config.companyId || !config.emailListId || !config.smsListId) return;
  const stages = [...dialog.querySelectorAll('[data-offer-step]')];
  const emailForm = dialog.querySelector('[data-offer-email]');
  const phoneForm = dialog.querySelector('[data-offer-phone]');
  const status = dialog.querySelector('[data-offer-status]');
  const key = 'joa-welcome-offer-v1';
  const params = new URLSearchParams(location.search);
  const preview = params.get('offer_preview') === '1';
  let stage = 'email', email = '', busy = false, trigger, controller, autoShown = false;
  const remember = days => { if (preview) return; try { localStorage.setItem(key, String(Date.now() + days * 86400000)); } catch {} };
  const suppressed = () => { try { return Number(localStorage.getItem(key)) > Date.now(); } catch { return false; } };
  const setStep = name => {
    stage = name;
    dialog.dataset.offerStage = name;
    stages.forEach(node => { node.hidden = node.dataset.offerStep !== name; });
    dialog.scrollTop = 0;
    status.textContent = '';
    const heading = dialog.querySelector(`[data-offer-step="${name}"] h2`);
    dialog.setAttribute('aria-labelledby', heading.id);
    if (dialog.open) heading.focus({ preventScroll: true });
  };
  function open(source) {
    if (dialog.open || busy) return;
    trigger = source instanceof HTMLElement ? source : document.activeElement;
    dialog.showModal();
    setStep(stage);
  }
  function close() {
    controller?.abort();
    dialog.close();
  }
  function code() { setStep('success'); remember(365); }
  const errorFor = form => form.querySelector('[data-offer-error]');
  async function subscribe(number) {
    const form = phoneForm;
    if (busy || !dialog.open || stage !== 'phone' || !email || !form.reportValidity()) return;
    busy = true;
    const button = form.querySelector('[type="submit"]');
    const original = button.textContent;
    button.disabled = true; button.textContent = config.copy.saving;
    form.setAttribute('aria-busy', 'true'); errorFor(form).textContent = '';
    const request = new AbortController();
    controller = request;
    const timeout = setTimeout(() => request.abort(), 20000);
    const signupEmail = email;
    try {
      for (const channel of ['email', 'sms']) {
        if (request.signal.aborted || !dialog.open) return;
        const attributes = {
          email: signupEmail,
          phone_number: number,
          properties: { joa_welcome_phone_provided: true },
          subscriptions: { [channel]: { marketing: { consent: 'SUBSCRIBED' } } }
        };
        const payload = { data: {
          type: 'subscription',
          attributes: { custom_source: `Jewels of Toronto welcome offer — required email and SMS signup (${channel})`, profile: { data: { type: 'profile', attributes } } },
          relationships: { list: { data: { type: 'list', id: channel === 'email' ? config.emailListId : config.smsListId } } }
        } };
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(config.companyId)}`, {
          method: 'POST', credentials: 'omit', signal: request.signal,
          headers: { accept: 'application/vnd.api+json', 'content-type': 'application/vnd.api+json', revision: '2026-07-15' },
          body: JSON.stringify(payload)
        });
        if (response.status !== 202) throw new Error('Subscription was not accepted');
      }
      if (!request.signal.aborted && dialog.open) { emailForm.reset(); phoneForm.reset(); email = ''; code(); }
    } catch {
      if (dialog.open) errorFor(form).textContent = config.copy.error;
    } finally {
      clearTimeout(timeout); busy = false; controller = null;
      button.disabled = false; button.textContent = original; form.removeAttribute('aria-busy');
    }
  }
  emailForm.addEventListener('submit', event => {
    event.preventDefault();
    if (busy || !emailForm.reportValidity()) return;
    email = emailForm.elements.email.value.trim();
    setStep('phone');
  });
  phoneForm.addEventListener('submit', event => {
    event.preventDefault();
    let number = phoneForm.elements.phone.value.replace(/[\s().-]/g, '');
    if (/^\d{10}$/.test(number) && ['CA', 'US'].includes(config.country)) number = '+1' + number;
    else if (/^1\d{10}$/.test(number) && ['CA', 'US'].includes(config.country)) number = '+' + number;
    if (!/^\+[1-9]\d{7,14}$/.test(number)) { errorFor(phoneForm).textContent = config.copy.phone_error; return; }
    subscribe(number);
  });
  dialog.querySelector('[data-offer-back]').addEventListener('click', () => { if (!busy) setStep('email'); });
  dialog.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', close));
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('close', () => {
    controller?.abort(); remember(stage === 'success' ? 365 : 7);
    if (stage !== 'success') { email = ''; emailForm.reset(); phoneForm.reset(); setStep('email'); }
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => {
    const box = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) close();
  });
  dialog.querySelector('[data-offer-copy]').addEventListener('click', async () => {
    const field = dialog.querySelector('[data-offer-code]');
    try { await navigator.clipboard.writeText(field.value); status.textContent = config.copy.copied; }
    catch { field.focus(); field.select(); status.textContent = config.copy.copy_manually; }
  });
  document.querySelectorAll('[data-joa-offer-open]').forEach(button => button.addEventListener('click', () => open(button)));
  const visible = node => node && !node.hidden && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden';
  const pageBusy = () => document.querySelector('dialog[open], .mw-tingle-modal--visible') ||
    [...document.querySelectorAll('#shopify-pc__banner, [data-testid="cookie-banner"], .klaviyo-form, .needsclick[role="dialog"]')].some(visible) ||
    document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
  const started = Date.now();
  const offerDelay = 105000;
  const scrollPosition = () => Math.max(scrollY, document.querySelector('.page-wrapper')?.scrollTop || 0);
  const offerWhenReady = () => {
    if (autoShown || suppressed() || Date.now() - started < offerDelay || scrollPosition() < 180 || pageBusy()) return;
    autoShown = true; open(); window.removeEventListener('scroll', offerWhenReady, true);
  };
  if (preview) open();
  if (!preview && !suppressed()) {
    window.addEventListener('scroll', offerWhenReady, { passive: true, capture: true });
    setTimeout(offerWhenReady, offerDelay + 500);
  }
})();

